import { useRef, useState } from 'react';
import { SaldoCardHero } from '../SaldoCardHero';
import { ExtratoLista } from './creditos/ExtratoLista';
import { VitrinePacotes } from './creditos/VitrinePacotes';

type Secao = 'vitrine' | 'extrato';

/**
 * Créditos (handoff §4): o saldo ao lado, e as duas seções em pílula (Comprar
 * crédito / Extrato).
 *
 * As abas eram as do shadcn pintadas com hex no `className`; viraram o
 * `toggle-pill` do painel. E o "Comprar crédito" do cartão de saldo não fazia
 * nada nesta aba ("já está na aba"): agora abre a vitrine.
 */
export function CreditosAba() {
  const [versao, setVersao] = useState(0);
  const [secao, setSecao] = useState<Secao>('vitrine');
  const vitrineRef = useRef<HTMLDivElement>(null);
  const recarregarTudo = () => setVersao(v => v + 1);

  return (
    <div className="co-creditos">
      <div key={`saldo-${versao}`}>
        <SaldoCardHero onComprarCredito={() => { setSecao('vitrine'); vitrineRef.current?.focus(); }} />
      </div>

      <div>
        <div className="co-cabecalho">
          <h1 className="co-titulo-tela">Créditos</h1>
          <div className="toggle-pill" role="radiogroup" aria-label="Seção">
            <input type="radio" id="co-secao-vitrine" name="co-secao" checked={secao === 'vitrine'} onChange={() => setSecao('vitrine')} />
            <label htmlFor="co-secao-vitrine">Comprar crédito</label>
            <input type="radio" id="co-secao-extrato" name="co-secao" checked={secao === 'extrato'} onChange={() => setSecao('extrato')} />
            <label htmlFor="co-secao-extrato">Extrato</label>
          </div>
        </div>

        <div ref={vitrineRef} tabIndex={-1} className="co-nota-livre">
          {secao === 'vitrine'
            ? <VitrinePacotes onPago={recarregarTudo} />
            : <ExtratoLista key={`extrato-${versao}`} />}
        </div>
      </div>
    </div>
  );
}
